/* eslint-disable react/no-array-index-key */
/* eslint-disable array-callback-return */
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { Button, LinearProgress, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { init } from 'echarts';
import { round } from 'mathjs';
import { cloneDeep } from 'lodash';

import './scale.scss';
import Color from '@tool/color';
import moScale from './store';
import Empty from '@/component/empty';
import moUser from '@store/user';
import moIndex from '../../store/index';

interface IProps {
  title: string
  list?: any[]
}
interface IState { }
interface IList {
  name: string,
  value: number,
}
interface IScaleResult {
  scale: string,
  ratio: number,
}

const Scale = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { title } = props;
  const { isLogin } = moUser;
  const { isMock } = moIndex;
  const portRef = useRef<any>(null);
  const [active, setActive] = useState<number>(0);
  const [max, setMax] = useState<number>(-1);
  // const { industryCode } = moTop;
  const { companyScale } = moScale;
  const industryCode = 4201000;

  // 获取最大值下标

  const getMaxIndex = (arr: any) => {
    let index = 0;
    if (arr?.length > 0) {
      let max: any = arr[0]?.value;
      // 声明了个变量 保存下标值
      for (let i = 0; i < arr.length; i += 1) {
        if (max < arr[i].value) {
          max = arr[i].value;
          index = i;
        }
      }
    }
    return index;
  };

  const render = (list: IList[]) => {
    init(portRef.current).dispose();
    const portrait = init(portRef.current);
    const option = {
      color: [Color.one, Color.two, Color.three, Color.four, Color.five, Color.six, Color.seven],
      // color: colors,
      tooltip: {
        show: false,
        trigger: 'item',
      },
      legend: {
        show: false,
      },
      series: [{
        type: 'pie',
        radius: ['80%', '90%'],
        // avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center',
          formatter: ['{c|{c}}%', '{b|{b}}'].join('\n'),
          rich: {
            b: {
              fontSize: '16px',
              color: Color.blackColor(0.65),
            },
            c: {
              fontSize: '24px',
              fontWeight: 500,
              color: Color.blackColor(0.85),
            },
          },
        },
        emphasis: {
          label: {
            show: true,
            fontSize: '20px',
            fontWeight: 500,
          },
        },
        labelLine: {
          show: false,
        },
        barWidth: 16,
        data: list,
      }],
    };
    portrait.setOption(option);

    const newMax = getMaxIndex(list);
    portrait.dispatchAction({
      type: 'highlight', // 突出高亮显示;
      seriesIndex: 0,
      dataIndex: newMax,
    });

    setActive(newMax);
    setMax(newMax);

    portrait.on('mouseover', (e: any) => {
      portrait.dispatchAction({
        type: 'downplay', // 突出高亮显示;
        seriesIndex: 0,
        dataIndex: newMax,
      });
      portrait.dispatchAction({
        type: 'highlight', // 突出高亮显示;
        seriesIndex: 0,
        dataIndex: e.dataIndex,
      });
      setActive(newMax);
    });
    portrait.on('mouseout', (e: any) => {
      setActive(newMax);
      portrait.dispatchAction({
        type: 'downplay', // 突出高亮显示;
        seriesIndex: 0,
        dataIndex: e.dataIndex,
      });
      portrait.dispatchAction({
        type: 'highlight', // 突出高亮显示;
        seriesIndex: 0,
        dataIndex: newMax,
      });
    });
  };

  const addMouseActive = (val: number) => {
    const portrait = init(portRef.current);
    const newList: IList[] = [];
    companyScale.map(item => {
      newList.push({
        name: item.scale,
        value: item.ratio,
      });
    });
    for (let i = 0; i < newList?.length; i += 1) {
      if (i !== val) {
        portrait.dispatchAction({
          type: 'downplay', // 突出高亮显示;
          seriesIndex: 0,
          dataIndex: i,
        });
      }
    }
    portrait.dispatchAction({
      type: 'highlight', // 突出高亮显示;
      seriesIndex: 0,
      dataIndex: val,
    });
  };

  const reRender = () => {
    if (companyScale.length > 0) {
      const newList: IList[] = [];
      companyScale.map(item => {
        newList.push({
          name: item.scale,
          value: round(item.ratio * 100, 1),
        });
      });
      render(newList);
    }
  };

  useEffect(() => {
    reRender();

    window.addEventListener('resize', reRender);

    return () => { window.removeEventListener('resize', reRender); };
  }, [industryCode, companyScale]);

  const removeMouseActive = (val: number) => {
    const portrait = init(portRef.current);
    portrait.dispatchAction({
      type: 'downplay', // 突出高亮显示;
      seriesIndex: 0,
      dataIndex: val,
    });
    portrait.dispatchAction({
      type: 'highlight', // 突出高亮显示;
      seriesIndex: 0,
      dataIndex: max,
    });
  };
  const DProgress = styled(LinearProgress)({
    width: '120px',
    borderRadius: '4px',
    backgroundColor: Color.blackColor(0.04),
  });

  return (
    <section className={[
      "scale-0102", !isMock ? '' : 'mock-100',
    ].join(' ')} id="market3">
      {companyScale.length > 0 ? (
        <section className="portrait-item-003">
          <section ref={portRef} className="portrait-item-02"
            style={{ width: '50%', height: '250px' }} />

          <section className="scale_0911">
            {companyScale.map((item, i) => (
              <section key={i}
                className={active === i ? 'progres-hover-item' : 'progress_0911'}
                onMouseEnter={() => { addMouseActive(i); setActive(i); }}
                onMouseLeave={() => { removeMouseActive(i); setActive(max); }}>
                <p>
                  <span>{item.scale}</span>
                  <DProgress variant="determinate"
                    value={round(item.ratio * 100, 1)} className={item.prop} />
                </p>
                <span className="value">{round(item.ratio * 100, 1)}%</span>
              </section>
            ))}
          </section>
        </section>
      ) : <Empty margin="80px 0 0 0" />}
    </section>
  );
};

export default observer(Scale);
